import Settings from 'assets/svgs/Settings'
import React from 'react'
import { Link } from 'react-router-dom'

const General = () => {
    return (
        <div>
            <div className='light-shadow py-4 px-2 flex flex-col gap-2 mt-4 rounded-lg'>
                <h3 className='mb-2 ml-1 font-semibold'>General</h3>
                <Link to='/user/settings' className='flex items-center gap-3 hover:text-primary cursor-pointer'>
                    <Settings />
                    <p>Settings</p>
                </Link>
                <Link to='/' className='flex items-center gap-3 hover:text-primary cursor-pointer'>
                    <i className="uil uil-sign-out-alt text-[22px]"></i>
                    <p>Logout</p>
                </Link>
                <div className='md:hidden block mt-4'>
                    <button className='btn-primary py-1.5'>
                        Create Compaign
                    </button>
                </div>
            </div>
        </div>
    )
}

export default General